import { transform } from '../../../../../../../../../frontend/libs/shared-vanilla/src/index';

/*
 * @IMPORTANT: for combo tiers - do not use this filter directly. Use - formatComboTierSpendLevel.filter
 * */
export default function FormatPlannedSpendLevelFilter($filter) {
  'ngInject';
  function currencyWithDefaults(amount: number) {
    return $filter('currency')(amount, '$', 0);
  }
  const percentFilter = $filter('percentage');
  const numberFilter = $filter('number');

  /*
   * @params truncateValue: boolean - when true, will make use of the abbreviatedNumberWithSuffix filter
   * */
  return function (value, type, truncateValue = false): string {
    return transform(
      value,
      type,
      truncateValue,
      currencyWithDefaults,
      percentFilter,
      numberFilter,
    );
  };
}
